<template>
	<side-window :tabs="tabs" :active="active" class="contact" title="E-mail" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div>
			<form-grid-layout>
				<div v-show="active == 'details'">
					<string-view label="Emne" v-model="entity.subject" :height="700" />
					<text-view label="Besked" v-model="entity.message" :height="600" />
					<div class="side-window__heading">
						Vedhæft filer
						<switch-view v-model="entity.attach" />
					</div>
				</div>
				<div v-show="active == 'recipients'">
					<text-view label="Modtagere" v-model="entity.recipients" :height="700" />
				</div>
			</form-grid-layout>
		</div>
		<div slot="footer">
			<button-view label="Send" @click="onSendButtonClick" />
		</div>
	</side-window>
</template>

<script>
	import TextView from '../views/TextView';
	import merge from '../functions/merge'

	export default {
		data: function () {
			return {
				active: 'details'
			};
		},
		components: {
			'TextView': TextView
		},
		computed: {
			tabs: function () {
				return [
					{
						name: 'details',
						label: 'Besked'
					},
					{
						name: 'recipients',
						label: 'Modtagere'
					}
				];
			}
		},
		props: {
			submit: {
				type: Function,
				default: function () { return true; }
			},
			entity: {
				type: Object,
				default() {
					return merge({}, {
						subject: '',
						recipients: '',
						message: '',
						attach: false
					});
				}
			}
		},
		methods: {
			tabSelect(name, tabName) {
				this.active = tabName;
			},
			onSendButtonClick() {
				var r = merge({}, this.entity);

				r.files = this.$store.state.attachments;

				this.submit(r);
			}
		}
	}
</script>

<style lang="scss">
	
</style>